// extracted by mini-css-extract-plugin
export var adjacentSlide = "_sz-9";
export var arrowButtonContainer = "_sz-5";
export var arrowButtonIcon = "_sz-6";
export var carouselArrowButton = "_sz-2";
export var carouselElementContainer = "_sz-1";
export var currentSlide = "_sz-8";
export var left = "_sz-3";
export var otherSlide = "_sz-a";
export var productCarouselContainer = "_sz-0";
export var right = "_sz-4";
export var sliderOverflow = "_sz-7";